(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-withdrawal-form]').forEach(initWithdrawalForm);
  });

  function initWithdrawalForm(wrapper) {
    var endpointPath = wrapper.getAttribute('data-withdrawal-endpoint');
    if (!endpointPath) return;

    var endpoint = new URL(endpointPath, window.location.origin).href;
    var form = wrapper.querySelector('[data-withdrawal-form-input]');
    var confirmStep = wrapper.querySelector('[data-withdrawal-form-confirm]');
    var successStep = wrapper.querySelector('[data-withdrawal-form-success]');
    var errorEl = wrapper.querySelector('[data-withdrawal-form-error]');
    var editButton = wrapper.querySelector('[data-withdrawal-form-edit]');
    var submitButton = wrapper.querySelector('[data-withdrawal-form-submit]');
    var successMessageEl = wrapper.querySelector('[data-withdrawal-form-success-message]');

    if (!form || !confirmStep || !successStep || !errorEl || !editButton || !submitButton) {
      return;
    }

    var summaryFields = {
      name: wrapper.querySelector('[data-withdrawal-summary="name"]'),
      email: wrapper.querySelector('[data-withdrawal-summary="email"]'),
      orderNumber: wrapper.querySelector('[data-withdrawal-summary="orderNumber"]')
    };

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      hideError();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      updateSummary();
      showStep(confirmStep);
    });

    editButton.addEventListener('click', function () {
      hideError();
      showStep(form);
    });

    submitButton.addEventListener('click', function () {
      hideError();
      submitWithdrawal(endpoint);
    });

    function getFormData() {
      return {
        name: form.elements.name.value.trim(),
        email: form.elements.email.value.trim(),
        orderNumber: form.elements.orderNumber.value.trim(),
        myshopifyDomain: form.elements.myshopifyDomain.value.trim()
      };
    }

    function updateSummary() {
      var data = getFormData();

      Object.keys(summaryFields).forEach(function (key) {
        if (summaryFields[key]) {
          summaryFields[key].textContent = data[key];
        }
      });
    }

    function showStep(activeStep) {
      [form, confirmStep, successStep].forEach(function (step) {
        step.hidden = step !== activeStep;
      });
    }

    function showError(message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function hideError() {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function setSubmitting(isSubmitting) {
      submitButton.disabled = isSubmitting;
      submitButton.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    }

    function submitWithdrawal(url) {
      var payload = getFormData();
      setSubmitting(true);

      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, status: response.status, data: data };
          });
        })
        .then(function (result) {
          if (result.ok) {
            var message =
              (result.data && result.data.message) ||
              'Din fortrydelsesanmodning er modtaget.';
            successMessageEl.textContent = message;
            showStep(successStep);
            form.reset();
            return;
          }

          var errorMessage =
            (result.data && result.data.message) ||
            'Der opstod en fejl. Prøv igen senere.';
          showError(errorMessage);
        })
        .catch(function () {
          showError('Der opstod en fejl. Prøv igen senere.');
        })
        .finally(function () {
          setSubmitting(false);
        });
    }
  }
})();
